import { useQueryClient } from '@tanstack/react-query'

import { useErrandsServiceDeleteV1IndividualsByIndividualIdErrandsByErrandId } from '../client/queries'
import { useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey } from '../client/queries/common'

export const useDeleteErrand = () => {
  const queryClient = useQueryClient()

  return useErrandsServiceDeleteV1IndividualsByIndividualIdErrandsByErrandId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey],
      })
    },
  })
}
